<script setup>
// Estúdio Social — sub-navegação compartilhada pelas 3 telas do módulo
// (Calendário/Contas/Métricas). O sidebar só tem UM item pro módulo
// inteiro (ver Sidebar.vue), então a troca entre as telas depende deste
// componente — sem ele, quem cai em /social/metrics direto (ex.: link
// salvo) fica sem volta pro calendário a não ser pelo browser.
// Reaproveita o vocabulário visual do TabBar.vue (pill bar bg-n-alpha-1,
// aba ativa bg-n-solid-active) só que orientado a rota (RouterLink) em vez
// de índice — as 3 telas são rotas de verdade, não abas de um único
// componente.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

const { t } = useI18n();
const route = useRoute();
const { accountScopedRoute } = useAccount();

// A aba "Contas" saiu daqui (decisão Ivan 25/08): conectar rede mora na
// tela Marketing → Conexões. A ROTA social_accounts_index continua viva —
// é o destino do redirect headless do OAuth (abre só dentro do popup).
const items = computed(() => [
  { name: 'social_calendar_index', label: t('SOCIAL_STUDIO.NAV.CALENDAR') },
  { name: 'social_production_index', label: t('SOCIAL_STUDIO.NAV.PRODUCTION') },
  { name: 'social_feed_index', label: t('SOCIAL_STUDIO.NAV.FEED') },
  { name: 'social_metrics_index', label: t('SOCIAL_STUDIO.NAV.METRICS') },
]);

const isActive = name => route.name === name;
</script>

<template>
  <nav class="flex items-center h-8 rounded-lg bg-n-alpha-1 w-fit">
    <RouterLink
      v-for="item in items"
      :key="item.name"
      :to="accountScopedRoute(item.name)"
      class="px-4 py-1.5 text-sm rounded-lg outline-1 outline transition-colors duration-300 ease-in-out"
      :class="
        isActive(item.name)
          ? 'text-n-blue-text bg-n-solid-active outline-n-container dark:outline-transparent'
          : 'text-n-slate-10 outline-transparent hover:text-n-brand'
      "
    >
      {{ item.label }}
    </RouterLink>
  </nav>
</template>
